import httpClient from './httpClient';

const baseEndpoint = '/api/blog'

const deleteBlogById = existingId => {
    return httpClient.delete(`${baseEndpoint}/secure/delete`, { params: { existingId } })
}

const saveBlog = request => {
    return httpClient.post(`${baseEndpoint}/secure/save`, request)
}

const updateBlog = (request, existingId) => {
    return httpClient.put(`${baseEndpoint}/secure/update`, request, { params: { existingId } })
}

const fetchBlogById = id => {
    return httpClient.get(`${baseEndpoint}/`, { params: { id } })
}

const fetchAllBlogs = (page, pageSize) => {
    return httpClient.get(`${baseEndpoint}/all`, { params: { page, pageSize } })
}

export {
    deleteBlogById,
    saveBlog,
    updateBlog,
    fetchAllBlogs,
    fetchBlogById
}